import { render, staticRenderFns } from "./OrderModelModular.vue?vue&type=template&id=c4210f90&"
import script from "./OrderModelModular.vue?vue&type=script&lang=js&"
export * from "./OrderModelModular.vue?vue&type=script&lang=js&"
import style0 from "./OrderModelModular.vue?vue&type=style&index=0&id=c4210f90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports